import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';
import { PopoverController } from '@ionic/angular';
import { OpcionesExportarComponent } from 'src/app/componentes/opciones-exportar/opciones-exportar.component';

@Component({
  selector: 'app-libros-utiles-servicios',
  templateUrl: './libros-utiles-servicios.component.html',
  styleUrls: ['./libros-utiles-servicios.component.scss'],
})
export class LibrosUtilesServiciosComponent implements OnInit {
  @Output() recargar = new EventEmitter();
  @Output() correo = new EventEmitter();
  @Output() desabilitar = new EventEmitter();
  disabled: boolean = true;

  filtro = ""
  filtroTipo = ""
  filtrado = false;
  todo = true;

  mostrarSeccion = false;

  @Input() UserID = ""

  @ViewChild('pdfTable') pdfTable: ElementRef;
  pdf: string = ""

  HijosSeleccionados = []

  Datos = []

  @Input() Hijos = JSON.parse(atob(localStorage.getItem(btoa('Hijos'))));
  HijosSelect = []

  constructor(private conexion: ConexionService, private utilidades: UtilidadesService,
    private popoverController: PopoverController) { }

  ngOnInit() {
    this.getConfiguraciones()
    setTimeout(() => {
      this.HayDatos()
    }, 30000);
    setTimeout(() => {
      for (let i of this.Hijos) {
        this.HijosSelect.push({
          Nombre: i.Nombre1 + ' ' + i.Apellido1,
          Foto: i.Url,
          Value: i.Id,
        });
        this.HijosSeleccionados.push(i.Id);
      }
      this.getLibrosUtilesServicios()
    }, 300);
  }

  Sumar() {
    let total = 0;
    for (let i of this.Datos) {
      if ((this.EnArreglo(i.IdCurso, this.HijosSeleccionados))) {
        total += Number(i.Precio)
      }
    }
    //sd
    return total;
  }

  async Exportar(e: Event) {
    const popover = await this.popoverController.create({
      component: OpcionesExportarComponent,
      event: e,
    });
    await popover.present();
    const { data } = await popover.onDidDismiss();

    this.utilidades.Depuracion(data, "console", "")
    if (data == "pdf") {
      this.pdfF()
    } else if (data == "excel") {
      this.exportexcel()
    }
  }

  getConfiguraciones() {
    this.conexion.getConfiguraciones().subscribe((resp) => {
      this.utilidades.Depuracion(resp, "console", "")
      for (let i of resp.Datos) {
        if (i.Configurable == "MostrarSeccionHijos") {
          if (Number(i.Dato) == 1) {
            this.mostrarSeccion = true;
          }
        }
      }
      // this.RNC=resp.Datos
    })
  }

  Tipo() {
    this.todo = false;
    setTimeout(() => {
      this.todo = true;
    }, 10);
  }

  Imprimir() {

    let vent = window.open('', '', 'height=800, width=800');
    vent.document.write(this.TextoMostrable())
    vent.document.close()
    setTimeout(() => {
      vent.print()
    }, 300);

  }

  FiltroPorDescripcion() {
    this.filtrado = true;
    let x = []
    let aux: any;
    for (let familias of this.Datos) {
      aux = familias;
      aux.Datos = familias.Datos.filter(f => f.NumeroDocumento.indexOf(this.filtro) > -1)
      x.push(aux)
    }


  }

  exp = "tablaExport"
  excel = false
  exportexcel(): void {
    this.excel = true
    this.exp = ""
    this.utilidades.Toast("Descargando Excel...", 3000, "download-outline")
    setTimeout(() => {
      /* table id is passed over here */
      // let element = document.getElementById('datos');
      // const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      // /* generate workbook and add the worksheet */
      // const wb: XLSX.WorkBook = XLSX.utils.book_new();
      // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      // /* save to file */
      // XLSX.writeFile(wb, "Libros, Utiles y Servicios " + String(new Date()) + ".xlsx");

      const downloadLink = document.createElement("a");
      const dataType = 'application/vnd.ms-excel';
      const table = document.getElementById("datos");
      const tableHtml = table.outerText.replace(/ /g, '%20')
      document.body.appendChild(downloadLink);
      downloadLink.href = 'data:' + dataType + ' ' + tableHtml;
      downloadLink.download = "Libros, Utiles y Servicios " + String(new Date()) + ".xls";
      downloadLink.click();

      this.excel = false
      this.exp = "tablaExport"
    }, 200);
  }

  TextoMostrable() {
    return '<!DOCTYPE html> <html lang="en"> <head> <meta charset="UTF-8"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> <meta name="viewport" content="width=device-width, initial-scale=1.0"> <title>Documentos pendientes</title> <style> *{font-family: "Arial", sans-serif !important; letter-spacing: 0.1px;} .h3{margin: 1px 2px 2px 2px; font-size: 15px; font-weight: 800;}  table{ border-collapse:separate; width: 100%; table-layout: fixed;} th { padding: 5px 10px; }  .table_header th { border-top: 1px solid black; border-bottom: 1px solid black; font-size: 11px;} .table_header th:last-child{ border-right: 1px solid black; border-top-right-radius: 5px !important; border-bottom-right-radius: 5px !important; } .table_header th:first-child { border-left: 1px solid black; border-top-left-radius: 5px !important; border-bottom-left-radius: 5px !important; }  td{ text-align: left; font-size: 11px;} .tdImp{ text-align: left; font-size: 11px; width: 70px !important;} .tdImpC{ text-align: left; font-size: 11px; width: 255px !important;}  .tdImp{ text-align: left; font-size: 11px; width: 110px !important;} .thImp{padding: 7px 10px; font-size: 11px; text-align: center; width: 70px;}  .desaparecibles { display: none; } table { border-collapse: separate; width: 100%; table-layout: fixed; } .table_header th { border-top: 1px solid black; border-bottom: 1px solid black; } .table_header th:last-child { border-right: 1px solid black; border-top-right-radius: 10px; border-bottom-right-radius: 10px; } .table_header th:first-child { border-left: 1px solid black; border-top-left-radius: 10px; border-bottom-left-radius: 10px; } .thImpE{padding: 7px 10px; font-size: 11px; text-align: center; width:110px;}  .thImpC{padding: 7px 10px; font-size: 11px; text-align: center; width:255px;} .tdEstudianteF{font-size: 11px !important;} .tdEstudiante{font-size: 11px !important;} .bEstudiante{ font-size: 11px; font-weight: bold !important;} </style> </head> <body> <div style="text-align: center; font-family: "Arial", sans-serif !important; "> <h3 class="h3"> INSTITUTO DE DESARROLLO INTEGRAL LEONARDO DA VINCI </h3> <p style="font-size: 11px; margin: 3px 1px;"> "SEA NUESTRO AVAL EL RECTO PENSAR" </p> <p style="font-size: 11px; margin: 3px 1px;"> CARR. DON PEDRO KM. 1 ESQ. C/ EL GUANO SANTIAGO, R.D. </p> <p style="font-size: 11px; margin: 1px;"> <b> Teléfono 809-734-1535</b> </p>  <p style="font-size: 10px; margin-top: 1px; margin-bottom: 15px;"><b>4-02-06333-9</b></p> <p style="font-size: 13px; margin: 1px;"> <b> LISTADO DE UTILES ESCOLARES </b> </p> <p style="font-size: 11px; margin: 0;"> <b>AÑO ESCOLAR {{2022-2023}} </b></p> </div> <br> {{Hola}} </body> </html>'.
      replace("{{Hola}}", document.getElementById("todo").innerHTML)
  }


  TextoMostrablePDF() {
    return '<!DOCTYPE html> <html lang="en"> <head> <meta charset="UTF-8"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> <meta name="viewport" content="width=device-width, initial-scale=1.0"> <title>Documentos pendientes</title> <style> *{font-family: "Arial", sans-serif !important; letter-spacing: 0.1px;} .h3{margin: 1px 2px 2px 2px; font-size: 12px; font-weight: bold;}  table{ border-collapse:separate; width: 100%; table-layout: fixed;} th { padding: 5px 10px; }  .table_header th { border-top: 1px solid black; border-bottom: 1px solid black; font-size: 9px;} .table_header th:last-child{ border-right: 1px solid black; border-top-right-radius: 4px !important; border-bottom-right-radius: 4px !important; } .table_header th:first-child { border-left: 1px solid black; border-top-left-radius: 4px !important; border-bottom-left-radius: 4px !important; }  td{ text-align: left; font-size: 9px;} .tdImp{ text-align: left; font-size: 9px; width: 70px !important;} .tdImpC{ text-align: left; font-size: 9px; width: 255px !important;}  .tdImp{ text-align: left; font-size: 9px; width: 110px !important;} .thImp{padding: 7px 10px; font-size: 9px; text-align: center; width: 70px;}  .desaparecibles { display: none; } table { border-collapse: separate; width: 100%; table-layout: fixed; } .table_header th { border-top: 1px solid black; border-bottom: 1px solid black; } .table_header th:last-child { border-right: 1px solid black; border-top-right-radius: 10px; border-bottom-right-radius: 10px; } .table_header th:first-child { border-left: 1px solid black; border-top-left-radius: 10px; border-bottom-left-radius: 10px; } .thImpE{padding: 7px 10px; font-size: 9px; text-align: center; width:110px;}  .thImpC{padding: 7px 10px; font-size: 9px; text-align: center; width:255px;} .tdEstudianteF{font-size: 9px !important;} .tdEstudiante{font-size: 9px !important;} .bEstudiante{ font-size: 9px; font-weight: bold !important;} </style> </head> <body> <div style="text-align: center; font-family: "Arial", sans-serif !important; "> <h3 class="h3"><b>INSTITUTO DE DESARROLLO INTEGRAL LEONARDO DA VINCI </b></h3> <p style="font-size: 9px; margin: 3px 1px;"> "SEA NUESTRO AVAL EL RECTO PENSAR" </p> <p style="font-size: 9px; margin: 3px 1px;"> CARR. DON PEDRO KM. 1 ESQ. C/ EL GUANO SANTIAGO, R.D. </p> <p style="font-size: 9px; margin: 1px;"> <b> Teléfono 809-734-1535</b> </p>  <p style="font-size: 9px; margin-top: 1px; margin-bottom: 15px;"><b>4-02-06333-9</b></p> <p style="font-size: 10px; margin: 1px;"> <b> LISTADO DE UTILES ESCOLARES </b> </p> <p style="font-size: 9px; margin: 0;"> <b>AÑO ESCOLAR {{2022-2023}} </b></p> </div> <br> {{Hola}} </body> </html>'.
      replace("{{Hola}}", document.getElementById("todo").innerHTML)
  }




  EnArreglo(valor, arreglo) {
    for (let i of arreglo) {
      if (Number(valor) == this.getCursoEstudiante(Number(i))) {
        return true;
      }
    }

    return false;
  }

  getCursoEstudiante(id_estudiante) {
    for (let i of this.Hijos) {
      if (Number(i.Id) == id_estudiante) {
        return i.IdCurso
      }
    }
  }


  pdfF() {
    this.utilidades.Toast("Descargando PDF...", 3000, "download-outline")
    let d = document.getElementById("imprimible")
    d.innerHTML = this.TextoMostrablePDF()
    this.pdf = "pedefeable"
    document.getElementById("cc").scrollTo({ top: 0, behavior: "smooth" })

    setTimeout(() => {
      let pd = new jspdf('p', 'pt', 'a4')
      pd.html(this.pdfTable.nativeElement, {
        "margin": [0, 0, 0, 0], "autoPaging": "text",
        callback: (pdf) => {
          pdf.save("Libros, Utiles y Servicios " + String(new Date()) + ".pdf")
          setTimeout(() => {
            d.innerHTML = ""
            this.pdf = ""
          }, 800);
        }
      })
    }, 100);

  }



  getLibrosUtilesServicios() {


    let secciones = ""
    for (let i of this.Hijos) {
      secciones += String(i.IdSeccion) + ", "
    }

    secciones = secciones.substring(0, secciones.length - 2)

    if (!secciones) return 0;

    this.utilidades.Loading("Cargando documentos")
    this.conexion.getLibrosUtilesServicios(secciones).subscribe((resp) => {
      this.desabilitar.emit(false)
      this.disabled = false;
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(resp, "console", "")
      if (resp.Respuesta == "Exito") {
        this.Datos = resp.Datos
        this.utilidades.Depuracion(resp.Datos, "console", "")
      }
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Alerta("En estos momentos este servicio no se encuentra disponible. Por favor, inténtelo más tarde.")
      this.desabilitar.emit(true)
      this.disabled = true;
      this.utilidades.ValidarUser(err)
    })
  }

  HayDatos(): boolean {
    if (document.getElementById("datos")) {
      if (document.getElementById("datos").innerText.length > 75) {
        return true;
      }
    }
    return false;
  }
}
